module.exports = __webpack_public_path__ + "img/cart.b20233e9.svg";